import { cn } from '@/lib/utils';
import { painelDialogSurfaceClass, workspaceControlClass } from '@/components/painel/painel-styles';

const painelFieldFocusClass = cn(
  'focus:border-sky-400/45 focus:outline-none focus:ring-2 focus:ring-sky-400/20 focus:ring-offset-0',
  'focus-visible:border-sky-400/45 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/20 focus-visible:ring-offset-0'
);

export const painelInputClass = cn(
  'h-10 w-full rounded-xl px-3 font-inter text-sm shadow-inner',
  workspaceControlClass,
  'transition-[border-color,box-shadow] hover:border-sky-400/25',
  painelFieldFocusClass,
  'disabled:opacity-50'
);

export const painelTextareaClass = cn(
  'min-h-[200px] w-full rounded-xl px-3 py-2 font-inter text-sm shadow-inner',
  workspaceControlClass,
  'transition-[border-color,box-shadow] hover:border-sky-400/25',
  painelFieldFocusClass,
  'disabled:opacity-50'
);

/** SelectTrigger no tema escuro do painel — sobrescreve ring branco do shadcn. */
export const painelSelectTriggerClass = cn(
  painelInputClass,
  'flex h-10 items-center justify-between text-left shadow-none [&>span]:line-clamp-1',
  'data-[state=open]:border-sky-400/45 data-[state=open]:ring-2 data-[state=open]:ring-sky-400/20 data-[state=open]:ring-offset-0'
);

export const painelDialogContentClass = cn(painelDialogSurfaceClass, 'max-w-lg p-6 sm:rounded-2xl');
